import { forwardRef } from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "É necessário instalar software?",
    a: "Não. O acesso é feito inteiramente via browser. Basta uma ligação à internet.",
  },
  {
    q: "Posso importar dados existentes?",
    a: "Sim. Suportamos importação massiva através de ficheiros Excel e XML.",
  },
  {
    q: "Como funciona a segurança?",
    a: "Utilizamos permissões Unix-style combinadas com RBAC, garantindo que cada utilizador vê apenas o que deve.",
  },
  {
    q: "O sistema é responsivo?",
    a: "Sim, a interface adapta-se automaticamente a tablets e dispositivos móveis.",
  },
  {
    q: "O número de utilizadores é limitado?",
    a: "Não. O Index Rerum permite a criação de qualquer número de utilizadores com login sem repercussão no preço.",
  },
  {
    q: "Existe limite para o número/tipo de fichas?",
    a: "Não. Qualquer número/tipo de registos é possível, incluindo áudio e vídeo.",
  },
  {
    q: "O que é possível inventariar?",
    a: "Tudo. Respeitamos a legislação nacional e as normas internacionais para todo o património tangível e intangível.",
  },
];

const FaqColumn = forwardRef<HTMLDivElement, { items: typeof faqs }>(({ items }, ref) => (
  <div ref={ref}>
    <Accordion type="single" collapsible className="divide-y divide-border">
      {items.map((faq, i) => (
        <AccordionItem key={i} value={`item-${i}`} className="border-0 px-0">
          <AccordionTrigger className="text-left font-semibold text-foreground hover:text-foreground/70 transition-colors font-serif py-6">
            {faq.q}
          </AccordionTrigger>
          <AccordionContent className="text-muted-foreground leading-relaxed pb-6">
            {faq.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  </div>
));

FaqColumn.displayName = "FaqColumn";

const FaqSection = forwardRef<HTMLElement>((_, ref) => {
  return (
    <section ref={ref} id="faq" className="py-24 bg-muted/50 border-y border-border">
      <div className="container mx-auto px-4 max-w-5xl">
        <div className="text-center mb-16">
          <p className="text-muted-foreground font-semibold text-xs uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground font-serif">
            Respostas Rápidas
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12">
          <FaqColumn items={faqs.slice(0, 4)} />
          <FaqColumn items={faqs.slice(4)} />
        </div>
      </div>
    </section>
  );
});

FaqSection.displayName = "FaqSection";

export default FaqSection;
